import { render, staticRenderFns } from "./userimage.html?vue&type=template&id=febd1fee&scoped=true&"
import script from "./userimage.js?vue&type=script&lang=js&"
export * from "./userimage.js?vue&type=script&lang=js&"
import style0 from "./userimage.scss?vue&type=style&index=0&id=febd1fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febd1fee",
  null
  
)

export default component.exports